import useCustomHook from '@/hooks/useCustomHook';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext, useEffect } from 'react';

export default function useSubscriptionForTeachers() {
  const globalContext = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      isTeacherPro: null,
      selectedLanguage: 'es',
    },
    actions: {
      setSelectedLanguage: (selectedLanguage) => {
        actions.setState({ selectedLanguage });
      },
    },
  });

  useEffect(() => {
    if (globalContext.state.loaded) {
      actions.setState({
        isTeacherPro: globalContext.state.isTeacherPro,
        selectedLanguage: globalContext.state.selectedLanguage,
        isTeacher:
          globalContext.state.subscription?.subscriptionType?.code == 'teacher',
      });
    }
  }, [globalContext.state.loaded]);

  return { state, actions };
}
